import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "warper clearfix" }
const _hoisted_2 = { class: "plug" }
const _hoisted_3 = { class: "grid-content bg-purple" }
const _hoisted_4 = { class: "grid-content bg-purple" }
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppMain = _resolveComponent("AppMain")!
  const _component_FooterBar = _resolveComponent("FooterBar")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppMain, { isMobile: _ctx.isMobile }, null, 8, ["isMobile"]),
    _createVNode(_component_FooterBar, { isMobile: _ctx.isMobile }, null, 8, ["isMobile"]),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cooperation",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible=true))
          }, [
            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "iconfont icon-shejiao-hezuo" }, null, -1)),
            _cache[12] || (_cache[12] = _createTextVNode()),
            _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('tag.text')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "totop",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotop && _ctx.gotop(...args)))
      }, [...(_cache[14] || (_cache[14] = [
        _createElementVNode("i", { class: "iconfont icon-shang" }, null, -1)
      ]))])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "合作加盟",
      center: "",
      width: "50%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.cancel(_ctx.ruleFormRef))),
            class: "btn btn1"
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef))),
            class: "btn btn2"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("提交", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ruleFormRef",
          size: "large",
          model: _ctx.ruleForm,
          rules: _ctx.rules,
          "label-width": "120px",
          class: "demo-ruleForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "单位名称",
              prop: "orgName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.ruleForm.orgName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.orgName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "申请人",
              prop: "userName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.ruleForm.userName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.userName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "联系电话",
              prop: "telephone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.ruleForm.telephone,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.telephone) = $event)),
                  maxlength: "11"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "邮箱",
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.ruleForm.email,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.email) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_form_item, {
                        label: "产品类型",
                        prop: "productType"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.ruleForm.productType,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.productType) = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "全部",
                                value: ""
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productType, (v, k) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: v.enumName,
                                  value: v.enumKey,
                                  key: k
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_form_item, {
                        label: "类型",
                        prop: "agencyStatus"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.ruleForm.agencyStatus,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.agencyStatus) = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (v, k) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: v.enumName,
                                  value: v.enumKey,
                                  key: k
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}